import * as types from "./mutation-types";

export default {
  [types.SET_ACCESS_TOKEN](state, payload) {
    state.access_token = payload;
  },

  [types.SET_REFRESH_TOKEN](state, payload) {
    state.refresh_token = payload;
  },

  [types.SET_CURRENT_USER](state, payload) {
    state.currentUser = payload;
  },

  [types.SET_IS_LOADING](state, payload) {
    state.isLoading = payload;
  }
};
